import { render, staticRenderFns } from "./deptTreeSelect.vue?vue&type=template&id=64795441&scoped=true"
import script from "./deptTreeSelect.vue?vue&type=script&lang=js"
export * from "./deptTreeSelect.vue?vue&type=script&lang=js"
import style0 from "./deptTreeSelect.vue?vue&type=style&index=0&id=64795441&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64795441",
  null
  
)

export default component.exports